export const actualites = [
  {
    id: 10,
    title: "Top arrivée aux Sables !",
    date: "Août 2026",
    images: [
      "/actu/actu_10/slide11_1.jpg",
      "/actu/actu_10/slide11_2.jpg",
      "/actu/actu_10/slide11_4.jpg",
      "/actu/actu_10/AC_260813MIA_2945-bd%20(1).jpg",
      "/actu/actu_10/AC_260813MIA_2952-bd%20(1).jpg",
      "/actu/actu_10/AC_260813MIA_2962-bd.jpg",
      "/actu/actu_10/VO_130826MA_2-8-bd.jpg",
      "/actu/actu_10/VO_130826MA_2-20-bd%20(1).jpg",
      "/actu/actu_10/slide17_1.jpg",
      "/actu/actu_10/slide17_2.jpg",
      "/actu/actu_10/slide17_3.jpg",
      "/actu/actu_10/slide17_4.jpg",
    ],
    excerpt: "Ils sont de retour ! Après une escale aux Açores et une étape retour sportive, Seb termine 10ème et Hugues 21ème aux Sables-d'Olonne. La Mini Atlantique est bouclée !",
    fullContent: `Ils sont de retour ! Après une escale bien méritée aux Açores qui a permis de réparer les bateaux un peu fatigués après la première étape, nos marins préférés sont repartis le 5 août dernier pour l'étape retour. Le début de course a été à nouveau sportif, avant de retrouver des conditions plus calmes dans le Golfe de Gascogne.

Seb (10ème aux Sables) : « Je suis ravi d'être arrivé, mais je suis complètement mort ! Les trois ou quatre premiers jours ont été particulièrement intenses et j'étais bien malade au début, sans doute un virus qui circulait à Horta. C'est long trois jours dans cet état : j'avais du mal à boire et à manger. Il a fallu prendre mon mal en patience et attendre que ça passe. Une fois rétabli, ça allait nettement mieux.

La fin de parcours s'est faite tout en douceur avec un vent plus faible. J'ai tenté un coup tactique en virant un peu plus tôt que le reste du groupe. Ça a particulièrement bien fonctionné : je cavalais depuis deux jours et j'ai pu regagner pas mal de places sur la ligne d'arrivée. C'est très satisfaisant d'avoir cette réussite sur la fin, on termine sur une super note ! »

Hugues (21ème aux Sables) : « C'est une aventure de fou furieux ! On est quand même allés jusqu'aux Açores sur des bateaux de seulement 6,50 mètres de long : je suis super heureux d'être là.
Côté compétition, c'était bien au début et un peu moins bien sur la fin. Mais j'ai préféré mettre le classement de côté sur les derniers milles pour réussir à en profiter pleinement. Il faut se rendre compte de la chance qu'on a : on est vraiment des privilégiés ! C'est tellement beau là-bas… On a notamment vu cette éclipse absolument magnifique, c'était une chance incroyable. Je suis vraiment ravi d'être arrivé aux Sables-d'Olonne.»`,
    links: [
      { label: "Le récap' complet de Seb", href: "https://www.sh-courseaularge.fr/miniatlantique-seb" },
    ],
  },
  {
    id: 9,
    title: "Bien arrivés à Horta !",
    date: "Juillet 2026",
    images: [
      "/actu/actu_9/VO_300726MA_-23-bd.jpg",
      "/actu/actu_9/FC_01634-bd.jpg",
      "/actu/actu_9/VO_310726MA_59570-bd.jpg",
    ],
    excerpt: "Après 8 jours de course, Seb et Hugues sont à bon port sur l'île de Faial. Quel voyage ! Les péripéties ont été nombreuses !",
    fullContent: `Après 8 jours de course, Seb et Hugues sont à bon port sur l'île de Faial. Quel voyage ! Les péripéties ont été nombreuses !

Seb (37ème à Horta) : « C'est con de se faire arrêter deux nuits de suite en arrivant dans l'archipel. Ça fait un peu mal, mais c'était chouette quand même. Le début était rapide, c'était cool, et ensuite il y a eu de la pétole, mais je ne m'en sortais pas si mal. Comme ils annonçaient du vent de sud-ouest, je me suis dit qu'il fallait passer au sud des îles. Mais il y a 20 ou 30 bateaux qui sont passés devant… On est quelques-uns à s'être fait avoir, c'est la loose ! N'empêche que ça reste une expérience de fou. Huit jours de course, c'est beaucoup ! »

Hugues (15ème à Horta) : « Ça s'est vraiment bien passé, de super conditions ! On a pu bien se bagarrer sur l'eau. Bon, la fin était un peu dure quand même : il fallait tricoter à droite et à gauche, je ne savais pas du tout où était le vent. Je suis un peu déçu sur le final à cause de ça, mais en même temps, on est tellement contents d'être là ! Ça donne la banane, c'est juste trop bien d'avoir traversé l'Atlantique.

Quand on arrive sur les îles, la sensation est unique. Déjà, en voyant les premières côtes, je me suis dit que c'était très différent de ce que je connaissais : c'est beaucoup plus vert, beaucoup plus lumineux. Quand je suis passé entre les deux grosses îles au milieu, les paysages avec les montagnes étaient spectaculaires. Ça fait vraiment rêver ! »`,
    links: [],
  },
  {
    id: 8,
    title: "Top départ de la Mini Atlantique !",
    date: "Juillet 2026",
    images: [
      "/actu/actu_8/VO_220726MA_-4-bd.jpg",
      "/actu/actu_8/AC_260722MIA_1510-bd.jpg",
      "/actu/actu_8/AC_260722MIA_1801-bd%20(1).jpg",
      "/actu/actu_8/VO_210726MA_56930-bd.jpg",
      "/actu/actu_8/VO_220726MA_57205-bd.jpg",
      "/actu/actu_8/753546263_28819934784273054_512406076682537204_n.jpg",
    ],
    excerpt: "La semaine de village aux Sables d'Olonne, puis le grand départ ce mercredi 22 juillet sur la première étape de la Mini Atlantique, 1300 milles nautiques vers Horta aux Açores !",
    fullContent: `La semaine de village aux Sables d'Olonne a été rythmée par la préparation des bateaux, mais aussi par de riches rencontres avec les associations France Rein, France Adot, Greffe de Vie et l'équipe coordinatrice des prélèvements d'organes de l'hôpital de La Roche sur Yon.

Hugues et Sébastien se sont élancés ce mercredi 22 juillet sur la première étape de la Mini Atlantique. Sous un grand soleil, ils ont entamé ce parcours de 1300 milles nautiques vers Horta aux Açores face à une cinquantaine de concurrents. Les premiers jours s'annoncent sportifs dans du vent fort pour la première moitié du parcours.

On les encourage !!`,
    links: [
      { label: "TV Vendée — Ils participent à la Mini Transat Atlantique pour sensibiliser au don d'organes", href: "https://tvvendee.fr/vivez-la-vendee/vivez-la-vendee-ils-participent-a-la-mini-transat-atlantique-pour-sensibiliser-au-don-dorgane/" },
      { label: "Cartographie de la Mini Atlantique", href: "https://lessables-lesacores650.fr/cartographie/" },
    ],
  },
  {
    id: 7,
    title: "La saison de courses 2026",
    date: "Avril 2026",
    images: [
      "/actu/actu_7/DJI_0018%20(1).jpg",
      "/actu/actu_7/AC_260502TBP_1705.jpg",
      "/actu/actu_7/AC_260502TBP_1772.jpg",
      "/actu/actu_7/AC_260504PS6_2267.jpg",
      "/actu/actu_7/AC_260504PS6_2283.jpg",
      "/actu/actu_7/723491528_1302230892063047_7374826652277822307_n.jpg",
      "/actu/actu_7/image6.jpeg",
      "/actu/actu_7/image7.jpeg",
      "/actu/actu_7/image8.jpeg",
      "/actu/actu_7/WhatsApp%20Image%202026-06-26%20at%2019.33.46.jpeg",
      "/actu/actu_7/WhatsApp%20Image%202026-06-26%20at%2019.33.46%20(1).jpeg",
      "/actu/actu_7/WhatsApp%20Image%202026-06-26%20at%2023.30.01.jpeg",
    ],
    excerpt: "Entre avril et juin, 5 courses différentes, de deux à six jours chacune. L'occasion d'inviter les équipes coordinatrices du don d'organes et leurs réseaux. Près d'une centaine de personnes venues à bord !",
    fullContent: `Entre avril et juin, nous participons à 5 courses différentes, de deux à six jours chacune. Cela nous permet à chaque fois d'inviter l'équipe coordinatrice du don d'organes de l'hôpital le plus proche avec leur réseau d'associations et de personnes greffées. Au total, près d'une centaine de personnes sont venues visiter nos bateaux et découvrir notre univers.

Chaque course est une aventure folle qui nous fait vivre des moments incroyables. Parmi les plus marquants : un record de lenteur lors d'une course en pleine canicule (200 milles parcourus à 3 nœuds de moyenne), des shots d'adrénaline notamment quand Hugues a dû monter en haut de son mât en solitaire, ou quand Sébastien a dû plonger en pleine nuit pour se libérer d'un paquet d'algues...

Et surtout une 7ème place sur 52 bateaux lors de l'unique course courue en double, après un aller-retour de 5 jours vers le sud de l'Irlande.`,
    links: [],
  },
  {
    id: 6,
    title: "Baptême des bateaux !",
    date: "Mars 2026",
    images: [
      "/actu/actu_6/Bapteme_SH_course_au_large-97.jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-102.jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-12%20(1).jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-30.jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-33.jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-84.jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-28%20(1).jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-42%20(1).jpg",
      "/actu/actu_6/Bapteme_SH_course_au_large-76%20(1).jpg",
    ],
    excerpt: "Nos bateaux sont décorés aux couleurs du ruban vert et baptisés Tous Donneurs et Tous Receveurs. Une cinquantaine de personnes réunies pour ce premier événement !",
    fullContent: `Entre deux entraînements d'hiver à Lorient, nos bateaux sont décorés aux couleurs du ruban vert grâce au formidable travail de l'équipe chez Objectif Numérique. C'est alors le moment d'officiellement lancer cette nouvelle saison de course pour la sensibilisation au don d'organes. Nos bateaux sont baptisés Tous Donneurs et Tous Receveurs.

Nous avons la chance d'être entourés par quatre parrains et marraines : une représentante d'une famille de donneur, une infirmière coordinatrice du don d'organes de l'hôpital de Lorient, un chirurgien spécialiste de la greffe et une personne greffée. C'est toute la chaîne du don qui est représentée !

Les associations de greffés de la région sont présentes avec quelques journalistes et nos partenaires. Une cinquantaine de personnes réunies pour ce premier événement !`,
    links: [
      { label: "Jaimeradio — À Lorient, des skippers s'engagent pour sensibiliser au don d'organes lors du baptême de bateaux de la SH Course au Large", href: "https://www.jaimeradio.fr/2026/03/17/don-organes-lorient-skippers/trame-reportage-15-2/" },
      { label: "Le Télégramme — Deux bateaux pour sensibiliser au don d'organes baptisés à la Maison des skippers, à Lorient", href: "https://www.letelegramme.fr/morbihan/lorient-56100/deux-bateaux-pour-sensibiliser-au-don-dorganes-baptises-a-la-maison-des-skippers-a-lorient-7001046.php" },
      { label: "À Lorient, une sensibilisation au don d'organes au travers de la course au large", href: "https://www.ouest-france.fr/bretagne/lorient-56100/a-lorient-une-sensibilisation-au-don-dorganes-au-travers-de-la-course-au-large-02caeca6-1d76-11f1-8354-21bcba10414b" },
    ],
  },
  {
    id: 5,
    title: "Changement de bateau et qualif' pour Hugues !",
    date: "Mars 2026",
    images: [],
    excerpt: "Redo le 1063 est rendu à son propriétaire, et Hugues passe sur Kirby, le 1055 ! Dans la foulée, c'est parti pour le parcours de qualif', comme Seb en septembre dernier.",
    fullContent: `Redo le 1063 est rendu à son propriétaire, et Hugues passe sur Kirby, le 1055 ! Dans la foulée avec seulement une navigation sur ce nouveau bateau, c'est parti pour le parcours de qualif', comme Seb en septembre dernier.

Le début sera frais et sportif dans un vent soutenu, tandis que la fin de parcours sera plus clémente pour laisser Hugues finir en moins de 8 jours.

Bravo, une nouvelle étape vers la mini Atlantique en juillet prochain !`,
    links: [
      { label: "La cartographie du parcours de Hugues", href: "https://carto.oceantracking.fr/miniqualif1055/carto" },
    ],
  },
  {
    id: 4,
    title: "La qualif' de Seb !",
    date: "Septembre 2025",
    images: [
      "/actu/actu_4/1761753378488.jpg",
      "/actu/actu_4/1761753380346.jpg",
    ],
    excerpt: "Un parcours de 1000 milles en solitaire, obligatoire pour se qualifier aux grandes courses du circuit mini. C'est chose faite pour Seb en ce mois de septembre !",
    fullContent: `Un parcours de 1000 milles en solitaire et hors course est obligatoire pour se qualifier aux grandes courses du circuit mini : la mini Atlantique et la mini Transat'. C'est chose faite pour Seb en ce mois de septembre, en 7 jours tout pile.

Rendez-vous en mars prochain pour le tour de Hugues !`,
    links: [
      { label: "Le récit complet de Seb", href: "https://data.sh-courseaularge.fr/" },
    ],
  },
  {
    id: 3,
    title: "Les premières courses !",
    date: "Avril 2025",
    images: [
      "/actu/actu_3/05072025-FAB_1128.jpg",
      "/actu/actu_3/05072025-FAB_1175.jpg",
      "/actu/actu_3/DSC_3776.JPG",
      "/actu/actu_3/DSC_3810.JPG",
    ],
    excerpt: "5 courses courues pendant la saison 2025 pour la team SH. Un océan de découvertes, d'apprentissage, de fatigue et d'émotions fortes rythmés par les rencontres avec les dauphins...",
    fullContent: `5 courses courues pendant la saison 2025 pour la team SH. Un océan de découvertes, d'apprentissage, de fatigue et d'émotions fortes rythmés par les rencontres avec les dauphins et les levés de soleil aux couleurs extraordinaires.

Une collision sur la première course en avril pour Seb engendrera un petit mois de chantier et pas mal de stress, mais il en faudra plus pour démotiver l'équipe.

La saison se terminera par les Calvados Cup à Deauville avec une belle 3ème place et un podium pour Seb !`,
    links: [],
  },
  {
    id: 2,
    title: "Les premiers entraînements",
    date: "Janvier 2025",
    images: [
      "/actu/actu_2/195-stage-mini-cc-mx.jpg",
      "/actu/actu_2/071-stage-mini-cc-mx.jpg",
      "/actu/actu_2/116-stage-mini-cc-mx.jpg",
      "/actu/actu_2/drone_hector_novembre.jpg",
      "/actu/actu_2/hugues_training.jpeg",
      "/actu/actu_2/redo_gennak_haut.jpg",
      "/actu/actu_2/speed_test_pres.jpg",
    ],
    excerpt: "C'est le début des entrainements avec le pôle de Concarneau, sous la houlette de François Jambou, vainqueur de la mini transat' 2019. Manœuvres, réglages, stratégie météo…",
    fullContent: `C'est le début des entrainements avec le pôle de Concarneau. Nous sommes entre 5 et 10 bateaux à nous entrainer un week-end sur deux sous la houlette de François Jambou, le coach, vainqueur de la mini transat' 2019.

Manœuvres, réglages, stratégie météo… Il y a tant à apprendre, c'est grisant !

C'est aussi le début de l'apprentissage de la maintenance des deux bateaux. Si on ne navigue pas un week-end sur deux, on répare, entretient, optimise le matériel pour prévenir de toute casse pendant la saison qui va suivre.`,
    links: [],
  },
  {
    id: 1,
    title: "Les premières mises à l'eau !",
    date: "Novembre 2024",
    images: [
      "/actu/actu_1/plouf_hector.jpg",
      "/actu/actu_1/convoyage.jpg",
      "/actu/actu_1/plouf_redo.jpg",
      "/actu/actu_1/Hector_spi.jpg",
      "/actu/actu_1/WhatsApp%20Image%202025-01-12%20at%2020.09.27.jpeg",
    ],
    excerpt: "Le projet prend vie ! Mise à l'eau de notre premier Mini 6.50, Hector (n°1039). Et deux mois plus tard, l'équipe est complète avec l'arrivée de Redo, le n°1063...",
    fullContent: `Le projet prend vie ! Mise à l'eau de notre premier Mini 6.50, le dénommé Hector portant le numéro 1039. Une journée chargée en émotions pour Seb et Hugues. Beaucoup d'excitation à l'idée de devenir propriétaire d'un tel bolide de course.

La mise à l'eau s'est déroulée sans accroc à La Rochelle avec l'ancien propriétaire. Les premières vérifications à flot ont confirmé que tout était en ordre. C'est le début d'une longue histoire pour apprendre à s'apprivoiser. Et sans perdre de temps, c'est aussitôt le moment du départ en convoyage vers Concarneau, son nouveau port d'attache. Viennent alors les premières images de large !

Deux mois plus tard, l'équipe est complète avec l'arrivée de Redo, le n°1063. La mise à l'eau se passe à Port La Forêt dans un froid et un brouillard bien breton, avant de rejoindre Concarneau sous le soleil.

Deux skippers et deux bateaux ! Les entraînements peuvent commencer avec le pôle de Concarneau.`,
    links: [],
  },
];
